export default "__VITE_ASSET__Bz$k9jZQ__"